'use client';
import styled from 'styled-components';

export const UnorderedList = styled.ul`
  padding-left: 1.5rem;
`;
